export default {
  computed: {
    commonFavoritesMenu() {
      return this.$store.getters.MOBILE_COMMON_FAVORITES_MENU;
    },
    favoritesLength() {
      let favorites = [];

      if (this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          album.items.forEach((photo) => {
            favorites.push(photo);
          });
        });
      }

      return favorites.length;
    },
  },
  methods: {
    goTo(favorite) {
      const path = this.i18nLink(`selected/${favorite.albumStatus === '2'
          ? `${favorite.albumHash}-${favorite.albumHashPassword}`
          : favorite.albumId}`);

      if (this.$route.path !== path) {
        this.$router.push(path);
      }

      this.$store.dispatch('SET_MOBILE_COMMON_FAVORITES_MENU', false);
    },
  },
};
